export { default } from 'features/home/routes/home-route';
